import { ReviewItem, SortType } from "~/components/Reviews/reviews.types";

export const sortAsc = (a: ReviewItem, b: ReviewItem) => {
  return new Date(a.scoreDate).getTime() - new Date(b.scoreDate).getTime();
};

export const sortDesc = (a: ReviewItem, b: ReviewItem) => {
  return new Date(b.scoreDate).getTime() - new Date(a.scoreDate).getTime();
};

export const sortReviews = (
  reviews: ReviewItem[],
  sortType: SortType,
): ReviewItem[] => {
  return reviews.sort((a, b) => {
    return sortType === SortType.DESC ? sortDesc(a, b) : sortAsc(a, b);
  });
};
